<template>
  <div class="productCard mx-1">
    <!-- Product Image -->
    <div class="cardImage " :style="{backgroundImage: `url('${getImageUrl(packages.imageMain)}')`}" @click="goPackagesDetail()"></div>

    <!-- Product Commission -->
    <div v-if="isShopOwner" class="commissionRateContainer commissionImg" >
      <span class="commissionRateText">{{getPercentage(packages.commissionRate)}}</span>
    </div>
    <!-- Product Content -->
    <div class="cardContent">
      <div class="row mx-0">
        <span class="text-left cardTitleTwoLine multiline-ellipsis ">{{getLocaleData(packages,'name' )}}</span>
      </div>
      <div class="row mx-0 mt-1 justify-content-between">
        <span class="d-block cardPrice primaryColorText">
          <span style="font-size: 0.8rem;">推廣價:{{$t('kol.priceUnit')}}</span> 
          <span style="font-size: 1rem;">{{ packages.marketPrice}}</span>
          <span v-if="packages.originalPrice !== '0'" style="font-size: 0.8rem; color: grey; text-decoration: line-through;">{{ packages.originalPrice}}</span>
        </span>
      </div>
        <!-- Full Product List -->
        <div v-if="getRouteStatus.module != 'Shop'">
          <!-- Not in Shopping Cart -->
          <b-col v-if="packagesQuantity == 0" cols="auto" class="row mx-0 px-0 justify-content-end " style="width: 175px ">
            <FITButton class="cardBtn mr-2" :iconOnly="true" faIcon="fa-heart" variant="outline-danger" @click.native="selectpackages()"></FITButton>
            <FITButton @click.native="addToCart()" class="cardBtn" :iconOnly="true" faIcon="fa-shopping-cart" variant="outline-danger"></FITButton>
          </b-col>
          <!-- In Shopping Cart -->
          <b-col v-else cols="auto" class="row mx-0 px-0 justify-content-between">
            <FITButton class="cardBtn mr-2" :iconOnly="true" faIcon="fa-minus" variant="outline-danger" @click.native="updatepackagesQuantity(-1)"></FITButton>
            <span class="px-1 primaryColorText">{{packagesQuantity}}</span>
            <FITButton @click.native="updatepackagesQuantity(1)" class="cardBtn" :iconOnly="true" faIcon="fa-plus" variant="outline-danger"></FITButton>
          </b-col>
        </div>
        <!-- KOL packages List -->
        <div v-else>
          <!-- Not in Shopping Cart -->
          <b-col v-if="packagesQuantity == 0" cols="auto" class="row mx-0 px-0 justify-content-between">
            <FITButton v-if="isShopOwner" class="cardBtn mr-2" :iconOnly="true" faIcon="fa-trash-alt" variant="outline-danger" @click="showDeleteConfirm"></FITButton>
          <!-- <FITButton v-if="isShopOwner " class="cardBtn mr-2" :iconOnly="true" faIcon="fa-share-square" variant="outline-danger" @click="shareCurrentPage" v-clipboard="copyData" @success="copySuccess" @error="copyError"></FITButton> -->   
         <FITButton @click.native="addToCart()" class="cardBtn" :iconOnly="true" faIcon="fa-shopping-cart" variant="outline-danger"></FITButton>
          </b-col>
          <!-- In Shopping Cart -->
          <b-col v-else cols="auto" class="row mx-0 px-0 justify-content-between">
            <FITButton class="cardBtn mr-2" :iconOnly="true" faIcon="fa-minus" variant="outline-danger" @click.native="updatepackagesQuantity(-1)"></FITButton>
            <span class="px-1 primaryColorText">{{packagesQuantity}}</span>
            <FITButton @click.native="updatepackagesQuantity(1)" class="cardBtn" :iconOnly="true" faIcon="fa-plus" variant="outline-danger"></FITButton>
          </b-col>
        </div>
    </div>
    <div v-transfer-dom>
      <alert :button-text="alertBtnText" v-model="showAlert">{{alertMsg}}</alert>
    </div>
    <div v-transfer-dom>
      <confirm :cancel-text="$t('kol.header.cancel')" :confirm-text="$t('kol.header.confirm')" v-model="showConfirm" :title="confirmMsg" @on-confirm="deletepackages"></confirm>
    </div>
    <div v-transfer-dom>
      <Actionsheet :cancel-text="$t('kol.header.cancel')" v-model="showAction" :menus="actions" show-cancel @on-click-menu="clickedAction">
      </Actionsheet>
    </div>
  </div>
</template>
<script type="text/javascript">
import { FITFormCard, FITCheckbox, FITSelect, FITTextInput, FITInputTag, FITButton } from '@/components'
import { mapGetters } from 'vuex'
import { Confirm, Actionsheet, XButton, Alert, TransferDom } from 'vux'
import Cookies from 'js-cookie'
export default {
  name: 'packagesCard',
  directives: {
    TransferDom
  },
  components: {
    Confirm,
    Actionsheet,
    Alert,
    XButton,
    FITCheckbox,
    FITSelect,
    FITTextInput,
    FITInputTag,
    FITButton,
    FITFormCard,

  },
  props: {

    value: {
      type: Object,
      default: () => {
        let obj = {}
        return obj;
      }
    }
  },
  data() {
    return {
      showAction: false,
      actions: [
        { label: '分享', value: 'share' },
        { label: this.$t('general.remove'), value: 'delete' },
      ],
      packages: this.value,
      showAlert: false,
      alertMsg: '',
      alertBtnText: this.$t('kol.header.confirm'),
      showConfirm: false,
      confirmMsg: '',
    }
  },
  created() {
    this.packages.quantity = this.packagesQuantity;
  },
  mounted() {},
  watch: {
    value: {
      handler: function(val, oldVal) {
        this.packages = val;
        this.packages.quantity = this.packagesQuantity;
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters([
      'getImageUrl',
      'getTranslatedData',
      // 'getCardQuantityByID', //changed to getPackageCardQuantityByID
      'getRouteStatus',
      'getPercentage'
    ]),
    isShopOwner() {
      let result = false;
      let role = this.currentRole;
      let currentShopLink = this.$router.currentRoute.query.link;
      let cookieShopLink = Cookies.get('shopLink');

      if(role == "K" || role == 'R'){
          result = true;
      }
      if(currentShopLink){
        if(currentShopLink == cookieShopLink){
          return true;
        }
      }
      return result;
    },
    packagesQuantity() {
      let packagesID;
      if (this.packages.packagesID) {
        packagesID = this.packages.packagesID;
      } else {
        packagesID = this.packages.ID;
      }
      let quantity = this.getCardQuantityByID(packagesID);
      return quantity;
    },
    currentRole() {
      return Cookies.get('role');
    },
    copyData() {
      let string = document.title + '\n\n';
      let copyData = 'https://mobile.kolpartner.com' + this.$router.currentRoute.fullPath;
      string += copyData;
      // console.log(string);
      return string;

    }

  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    clickedAction(action) {
      switch (action) {
        case 'delete':

          this.showDeleteConfirm();
          break;
        case 'share':
          this.shareCurrentPage();
          break;
      }
    },

    goPackagesDetail() {
      console.log(this.getRouteStatus.module)
      switch (this.getRouteStatus.module) {
        case 'Package':
          this.$router.push({
            name: 'Package Detail',
            params: {
              value: this.packages
            },
            query: {
              ID: this.packages.ID
            }
          });
          break;

          // default:
        case 'Shop':
          //  packages Link
          let param = {
            link: this.packages.link,
          }
          this.$store.dispatch('Shop/getKOLPackagesDetail', param).then((json) => {
            let packagesDetail = json.data;

            // Get Kol Shop Link
              let shopLink = '';
                  if(this.isShopOwner){
                      shopLink = Cookies.get('shopLink');
                  }else{
                      shopLink = this.$router.currentRoute.query.link;
                  }

            this.$router.push({
              name: 'Package Detail',
              params: {
                value: packagesDetail
              },
              query: {
                packages: this.packages.link,
                link: shopLink,
              }
            });

          })

          break;
      }
    },
    getLocaleData(data, key) {
      return this.getTranslatedData(this.$i18n.locale, data, key);
    },
    selectPackages() {
      this.$store.dispatch('Product/selectPackages', { productID: [this.packages.ID] }).then((json) => {
        this.alertMsg = this.$t('product.list.selectSuccess');
        this.showAlert = true;
      });
    },
    deletepackages() {
      this.$store.dispatch('Shop/deletepackages', { ID: [this.packages.ID] }).then((json) => {
        this.showConfirm = false;
      });
    },
    addToCart() {
      this.packages.quantity = 1;
      this.$store.dispatch('addPackagesToCart', this.packages);
      this.$router.push({
        name:"Package Checkout",
        params:{package:this.packages}
      })

    },
    updateProductQuantity(delta) {
      this.product.quantity += delta;
      // console.log(this.product);
      this.$store.dispatch('updateProductInCart', this.product);
    },

    showDeleteConfirm() {
      this.showAction = false;
      this.confirmMsg = this.$t('product.list.removeConfirm');
      this.showConfirm = true;
    },
    shareCurrentPage() {
      this.alertBtnText = this.$t('shop.detail.shareConfirmText');
      this.alertMsg = this.$t('shop.detail.shareBodyText');
      this.showAlert = true;
    },
    copySuccess(e) {
      // console.log('Success: ' + e );
    },
    copyError(e) {
      // console.log('Error: ' + e );
    }
  }
}

</script>
<style type="text/css">
.productCard {
  background: white;
  border-radius: 5px;
}

.cardImage {
  width: 100%;
  padding-top: 100%;
  background-position: 50% 50%;
  background-repeat: no-repeat;
  background-size: cover;
  border-top-right-radius: 5px;
  border-top-left-radius: 5px;
  cursor: pointer;

}

.cardTitleTruncate {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
  display: inline-block;
  overflow: hidden;
  text-overflow: -o-ellipsis-lastline;
  white-space: nowrap;
}

.cardTitleTwoLine {
  font-weight: 500;
  color: #333;
  font-size: 0.9rem;
  display: inline-block;
  overflow: hidden;
  height: 45px;
}

.multiline-ellipsis {
  display: block;
  display: -webkit-box;
  max-width: 400px;
  margin: 0 auto;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cardContent {
  padding: 10px 10px;
}

.cardPrice {
  margin-left: 3px;
  font-size: 1rem;
  font-weight: 500;

}

.cardBtn {
  margin: 0px 2px !important;
  font-size: 0.8rem;
  padding: 2px 6px;
  float: right;
  cursor: pointer;

}

.dotStyle {
  color: #888;
}
.commissionImg{
  background-image: url('../../assets/img/commissionTag.png');
}
</style>



// WEBPACK FOOTER //
// src/Package/components/PackageCard.vue